import { messageGroups } from '../plugins/i18n'

import './routes'
import './sidebar'

messageGroups.push('airportslist')
messageGroups.push('divisions')
messageGroups.push('company')
messageGroups.push('vehiclelist')
messageGroups.push('vehicles')
